const awsConfig = {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    // identityPoolId: "us-west-2:ca338c89-8c82-40d6-b22d-c928b4e3891b",

    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_USER_POOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: "OmniAPI",
        endpoint: `https://${process.env.REACT_APP_API_HOST}.execute-api.us-west-2.amazonaws.com/`,
      },
      {
        name: "OmniSES",
        // endpoint: `https://63f8n8uvrl.execute-api.us-west-2.amazonaws.com/`,
        endpoint: `https://${process.env.REACT_APP_API_SES}.execute-api.us-west-2.amazonaws.com/`,
      },
    ],
    aws_project_region: process.env.REACT_APP_REGION,
  },
};

// const awsConfig = {
//   //DEPLOY THIS VERSION YOU IDIOT, DEMO
//   Auth: {
//     // REQUIRED - Amazon Cognito Identity Pool ID
//     // identityPoolId: "us-west-2:ca338c89-8c82-40d6-b22d-c928b4e3891b",

//     // REQUIRED - Amazon Cognito Region
//     region: "us-west-2",

//     // OPTIONAL - Amazon Cognito User Pool ID
//     userPoolId: "us-west-2_HNjc5INBn",

//     // OPTIONAL - Amazon Cognito Web Client ID
//     userPoolWebClientId: "2il5lcou5naitmkqg8hvh370nr",

//     // might need this for demo links
//     // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
//     //  mandatorySignIn: false,

//     //     // OPTIONAL - Configuration for cookie storage
//     // // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
//     // cookieStorage: {
//     //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
//     //         domain: '.yourdomain.com',
//     //     // OPTIONAL - Cookie path
//     //         path: '/',
//     //     // OPTIONAL - Cookie expiration in days
//     //         expires: 365,
//     //     // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
//     //         sameSite: "strict" | "lax",
//     //     // OPTIONAL - Cookie secure flag
//     //     // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
//     //         secure: true
//     //     },
//   },
//   API: {
//     endpoints: [
//       {
//         name: "OmniAPI",
//         endpoint: `https://g4unc2hzte.execute-api.us-west-2.amazonaws.com/`,
//       },
//     ],
//     aws_project_region: "us-west-2",
//   },
// };

// // THIS IS FOR DEV ONLY,DON"T CHECK IT IN
// const awsConfig = {
//   Auth: {
//     // REQUIRED - Amazon Cognito Identity Pool ID
//     // identityPoolId: "us-west-2:ca338c89-8c82-40d6-b22d-c928b4e3891b",//original

//     // REQUIRED - Amazon Cognito Region
//     region: "us-west-2",

//     // OPTIONAL - Amazon Cognito User Pool ID
//     userPoolId: "us-west-2_HNjc5INBn",

//     // OPTIONAL - Amazon Cognito Web Client ID
//     userPoolWebClientId: "2est1ae37vm91ruiimt0kbnfk4",

//     // might need this for demo links
//     // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
//     //  mandatorySignIn: false,

//     //     // OPTIONAL - Configuration for cookie storage
//     // // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
//     // cookieStorage: {
//     //     // REQUIRED - Cookie domain (only required if cookieStorage is provided)
//     //         domain: '.yourdomain.com',
//     //     // OPTIONAL - Cookie path
//     //         path: '/',
//     //     // OPTIONAL - Cookie expiration in days
//     //         expires: 365,
//     //     // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
//     //         sameSite: "strict" | "lax",
//     //     // OPTIONAL - Cookie secure flag
//     //     // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
//     //         secure: true
//     //     },
//   },
//   API: {
//     endpoints: [
//       {
//         name: "OmniAPI",
//         endpoint: `https://judjguziyi.execute-api.us-west-2.amazonaws.com/`,
//       },
//     ],
//     aws_project_region: "us-west-2",
//   },
// };

export default awsConfig;
